<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'purchase-planning-orders-list'"
    ref="purchase-planning-orders-list"
    :loadDataGrid="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { PurchaseOrderDetail } from "../../_services/api/purchasing/purchase-order-detail.service";
import { PurchaseOrder } from "../../_services/api/purchasing/purchase-order.service";
import { FeatureStorage } from "../../_services/storage";
import {
  PurchasePlanningTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/purchasing/purchase-planning-tabs";
import { PurchasePlanningService } from "../../_services/api/purchasing/purchase-planning.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      localDataList: undefined,
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Purchase Planning",
        ScreenName: "Purchase Planning Orders",
        selectedIndex: GetIndexByTabName("Orders"),
        tabs: PurchasePlanningTabs,

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "PurchasePlanningPurchaseOrderList",
              filter: [
                [
                  `PurchasePlanningRunId`,
                  `=`,
                  decodeURI(this.baseView.query.run_id),
                ],
              ],
              allowGrouping: false,
              keyType: "Guid",
              key: "PurchasePlanningRunId",
              // localDataList: true,
              // items: this.localDataList,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Purchase Orders",
                message: "Get Started, Add a PO",
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            // customButtons: [
            //   {
            //     icon: "plus",
            //     label: "Add New",
            //     route: "/purchase-order/create",
            //     clickAction: {},
            //     buttonLocation: "left",
            //   },
            // ],
          },
          columns: [
            {
              screenField: "PurchaseOrder",
              gridDataField: "PurchaseOrder",
              minWidth: 140,
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
            },
            {
              screenField: "Supplier",
              gridDataField: "SupplierCode",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SupplierCode",
                  label: "Supplier Code",
                },
                {
                  dataField: "SupplierName",
                  label: "Supplier Name",
                },
              ],
              filterDataField: "SupplierCode",
              filterIndex: 0,
            },
            {
              screenField: "DateIn",
              gridLabel: "Date In",
              filterLabel: "Date In",
              filterIndex: 1,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 2,
              dataSourceConfig: {
                data: ["Active", "Completed", "Cancelled", "Draft"],
              },
              filterDefaultValue: ["Active", "Draft"],
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "PurchaseOrder",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "PurchaseOrder",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Complete Order",
                      data: data,
                      clickAction: this.completeOrder,
                      visible: data.data.GoodsReceived == "Y" ? true : false,
                      disabled:
                        data.data.Status == "C" || data.data.Status == "X"
                          ? true
                          : false,
                    },
                    {
                      menuText: "Cancel Order",
                      data: data,
                      clickAction: this.cancelOrder,
                      visible: data.data.GoodsReceived == "N" ? true : false,
                      disabled:
                        data.data.Status == "C" || data.data.Status == "X"
                          ? true
                          : false,
                    },
                    {
                      menuText: "Invoice",
                      data: data,
                      clickAction: this.goToSupplierInvoice,
                      visible: FeatureStorage.checkPermission(
                        "SupplierInvoice",
                        "create"
                      )
                        ? true
                        : false,
                      disabled:
                        data.data.GoodsReceived == "Y" &&
                        data.data.Invoiced == "N"
                          ? false
                          : true,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                if (
                  !FeatureStorage.checkPermission("PurchaseOrder", "create") ||
                  data.data.Status == "X"
                )
                  return true;
                else return false;
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    goToSupplierInvoice(e) {
      this.$router.push({
        path: "/supplier-invoice/create/" + e.PurchaseOrder,
        query: {
          from: "purchase-order",
        },
      });
    },
    async getDetailRecord(id) {
      return await PurchaseOrderDetail.getByCode(id);
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "purchase-order",
          mode: "review",
          idProperty: "PurchaseOrder",
          query: {
            from: this.$router.currentRoute.fullPath,
          },
        });
      }
    },
    async completeOrder(e, grid) {
      let confirmcompletel = await this.$confirm(
        "Do you want to complete this order?",
        "Complete Order"
      );

      if (confirmcompletel) {
        this.setLoading = true;
        await PurchaseOrder.completeOrder({ Code: e.PurchaseOrder })
          .then((res) => {
            if (res) this.setLoading = false;
            grid.refresh(true);
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Complete Complete Failed",
            });
          });
      }
    },
    async cancelOrder(e, grid) {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this order?",
        "Cancel Order"
      );

      if (confirmCancel) {
        this.setLoading = true;
        await PurchaseOrder.cancelOrder({ Code: e.PurchaseOrder })
          .then((res) => {
            if (res) this.setLoading = false;
            grid.refresh(true);
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Complete Cancel Failed",
            });
          });
      }
    },
  },

  async created() {},
  async beforeMount() {
    this.setLoading = true;
    await PurchasePlanningService.getCustomData({
      url: "PurchasePlanningPurchaseOrderList",
      filter: `PurchasePlanningRunId eq ${decodeURI(
        this.baseView.query.run_id
      )}`,
    })
      .then((res) => {
        this.localDataList = res.data.value;
        this.setLoading = false;
        this.loaded = true;
      })
      .catch((err) => {
        if (err) {
          this.localDataList = [];
          this.setLoading = false;
          this.loaded = true;
        }
      });
  },
};
</script>

<style lang="scss"></style>
